import { useState } from "react";
import TabNav from "../../composants/TabNav/TabNav";
import './Aide.css';

export default function MentionsPage() {
    const [activeTab, setActiveTab] = useState(0);

    // Définition des onglets
    const tabs = ["Conditions générales", "Politique de sécurité", "Mentions légales"];

    return (
        <div className="mentions-container">
            <h1>Mentions</h1>

            <TabNav
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={(index) => setActiveTab(index)}
            />

            {/* Politique de sécurité */}
            {activeTab === 0 && (
                <div className="mentions-content fullpage">

                    <iframe
                        src="/cgv"
                        title="Conditions Générales"
                        className="mentions-iframe"
                    />
                </div>
            )}

            {/* Conditions générales */}
            {activeTab === 1 && (
                <div className="mentions-content fullpage">
                    <iframe
                        src="/securite"
                        title="Politique de sécurité"
                        className="mentions-iframe"
                    />
                </div>
            )}


            {/* Mentions légales */}
            {activeTab === 2 && (
                <div className="mentions-content fullpage">
                    <iframe
                        src="/mentions-legales"
                        title="Mentions légales"
                        className="mentions-iframe"
                    />
                </div>
            )}
        </div>
    );
}